import * as React from 'react';
import { Box, Typography, Modal, Button } from '@mui/material';
import { useAppSelector } from "@store/hooks";
import { ui, state } from '../../interfaces/interfaces';
import { cacheUtils } from '../..';
import { CacheTypes } from '../../utilities/cache/interfaces';
import { displayRequiredModal } from '../Layout/BookingForm/MainForm/Steps/StepOne/ProblemDetails/RequiredOptions';
import { dispatchSetSnackMsgSuccess } from "@reducers/uiReducer";

const modalStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

interface IGenericPopupModalProps {
    modalTitle: string;
    adviseList: string[];
    buttonText: string;
    altJobTypes?: string[];
}

const GenericPopupModal: React.FC<IGenericPopupModalProps> = ({ modalTitle, adviseList, buttonText, altJobTypes }) => {
    const open = useAppSelector(({ ui }) => ui.GenericPopupModal);
    const jobTypeOptions = cacheUtils.getCache<CacheTypes.JobTypeOptions>("JobTypesOptions");

    const handleClose = () => {
        ui.GenericPopupModal = false;
    };

    const handleJobTypeChange = (jobType: string) => {
        const selectedJobType = jobTypeOptions.find(job => job.jobTypeCode === jobType);
        if (selectedJobType) {
            ui.ProblemComboJobSearch = selectedJobType;
            state.RequiredOptionsChanged = true;
            dispatchSetSnackMsgSuccess({
                ProblemMsg: "Job type changed to " + selectedJobType.jobDescription,
            });
            displayRequiredModal();
        }
    };

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={modalStyle}>
                <Typography id="modal-modal-title" variant="h4" component="h2" color="red" textAlign="center">
                    {modalTitle}
                </Typography>
                {adviseList.map((item, index) => (
                    <Typography key={index} sx={{ mt: 2 }}>
                        {item}
                    </Typography>
                ))}
                {altJobTypes && altJobTypes.map((jobType, index) => (
                    <Button key={index} variant="contained" color="primary" onClick={() => handleJobTypeChange(jobType)} sx={{ mt: 5, mr: 2 }}>
                        {jobTypeOptions.find(job => job.jobTypeCode === jobType)?.jobDescription || jobType}
                    </Button>
                ))}
                <Button sx={{ mt: 5 }} variant="contained" color="error" onClick={handleClose}>
                    {buttonText}
                </Button>
            </Box>
        </Modal>
    );
}

export default React.memo(GenericPopupModal);
